/**
 * Shared constants for the Lesson Planner admin pages.
 * Level codes match GRADE_GROUP_LEVEL_MAP / LEVEL_CHOICES on the backend
 * (apps/oh_lesson_planner/constants.py). K1 -> LKG.
 */
export const PLANNER_LEVEL_OPTIONS = {
  TODLR: 'Toddler',
  PRENUR: 'Pre-nursery',
  NUR: 'Nursery',
  LKG: 'K1 / LKG'
}

// QOT (Quality Observation Template) — must match QOT_SETUP_KEYS /
// QOT_FACILITATION_KEYS in apps/oh_lesson_planner/constants.py.
export const PLANNER_QOT_SETUP = [
  { key: 'aligned', title: 'Session aligned with the lesson plan' },
  { key: 'narrative', title: 'Narrative', desc: 'The space experientially sets the context for immersion. 2+ senses engaged.' },
  { key: 'layoutFlow', title: 'Layout & Flow', desc: 'Clear boundaries, intentional movement flows and designated seating as applicable.' },
  { key: 'cleanup', title: 'Clean up', desc: 'Children know where they can return all items to without an adult\'s help.' },
  { key: 'purpose', title: 'Purpose', desc: 'A clear agenda is visible through the setup — half-done work or materials in use suggest the process.' },
  { key: 'anchorChoice', title: 'Anchor & Choice materials', desc: 'An irresistible hero "anchor" material plus a variety of other "choice" materials that can be used flexibly.' },
  { key: 'sparkCuriosity', title: 'Spark Curiosity', desc: 'Has a "wow" element that invites wonder, questions or exploration.' },
  { key: 'challengeAdjustment', title: 'Challenge Adjustment', desc: 'Prepared with materials to change difficulty at an individual or group level.' },
  { key: 'selfServed', title: 'Self Served', desc: 'Materials are safe, recognisable and light enough for children to manage alone.' }
]

export const PLANNER_QOT_FACILITATION = [
  { key: 'transitions', title: 'Transitions', desc: 'Smooth transitions and predictable routines.' },
  { key: 'behaviourManagement', title: 'Behaviour Management', desc: 'Able to manage behaviour without disrupting the class or flow of play.' },
  { key: 'engagement', title: 'Engagement', desc: 'Ensures all children are engaged or attempts to engage them when they are not.' },
  { key: 'coach', title: 'Coach', desc: 'Offers hints, gentle scaffolds and next-step nudges.' },
  { key: 'commentator', title: 'Commentator', desc: 'Narrates play and thinks out loud to model thought process.' },
  { key: 'coplayer', title: 'Co-player', desc: 'Joins in the play to renew interest, demonstrate risk-taking or appropriate use of materials.' },
  { key: 'documentor', title: 'Documentor', desc: 'Uses observation data to inform setup, grouping and facilitation.' }
]

const WEEKDAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
export const PLANNER_WEEKDAY_NAMES = WEEKDAY_NAMES

// Monday (YYYY-MM-DD) of the week containing `d`.
export const mondayOf = (d) => {
  const date = new Date(d)
  // Guard empty / partial / invalid input (e.g. while editing a date field) —
  // toISOString() throws RangeError on an Invalid Date.
  if (isNaN(date.getTime())) return ''
  const day = (date.getDay() + 6) % 7 // 0 = Monday
  date.setDate(date.getDate() - day)
  return date.toISOString().slice(0, 10)
}
